import { useEffect, useRef } from 'react';

export function useJobsPolling(active, callback, intervalMs) {
    const callbackRef = useRef(callback);
    callbackRef.current = callback;

    useEffect(() => {
        if (!active) return;
        let stopped = false;
        let timer;

        const tick = async () => {
            try {
                await callbackRef.current();
            } catch (error) {
                console.error('Polling call failed:', error);
            }
            if (!stopped) timer = setTimeout(tick, intervalMs);
        };

        timer = setTimeout(tick, intervalMs);
        return () => {
            stopped = true;
            clearTimeout(timer);
        };
    }, [active, intervalMs]);
}
